export const departments = [
    {

        id: "D757248",
        department: "Admin",
        status: "Active",
    },
    {

        id: "D757247",
        department: "Finance",
        status: "Active",
    },
    {

        id: "D757246",
        department: "Academic",
        status: "Active",
    },
    {

        id: "D757245",
        department: "Library",
        status: "Active",
    },
    {

        id: "D757244",
        department: "Health",
        status: "Inactive",
    },
    {

        id: "D757243",
        department: "Transport",
        status: "Active",
    },
    {

        id: "D757242",
        department: "Hostel",
        status: "Active",
    },
    {

        id: "D757241",
        department: "Management",
        status: "Active",
    },
    {

        id: "D757240",
        department: "Guidance",
        status: "Inactive",
    },
    {

        id: "D757239",
        department: "Sports",
        status: "Active",
    }
]
